import React from 'react';

const TeamSection: React.FC = () => {
  const experts = [
    {
      name: "韩博士",
      title: "副高",
      specialty: "人工智能与医学数据建模",
      description: "长期致力于将机器学习与深度学习技术应用于临床大数据、多组学数据的分析与疾病预测模型开发，擅长从复杂数据中提炼可用于临床判断的关键信息。",
      clinicalValue: "可帮助构建疾病预测模型、发展新型诊断/分型工具。",
      image: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20doctor%20in%20her%2030s%20wearing%20white%20lab%20coat%2C%20AI%20and%20medical%20data%20modeling%20expert%2C%20artificial%20intelligence%20researcher%20in%20healthcare%2C%20clean%20white%20background%2C%20professional%20headshot%20portrait%20style&width=300&height=300&seq=expert-han-female&orientation=squarish",
      journals: ["Nature Methods", "JACC", "Nature Communications", "Nucleic Acids Research"]
    },
    {
      name: "何博士",
      title: "副高",
      specialty: "单细胞与癌症多组学研究",
      description: "长期从事肿瘤组织异质性、肿瘤微环境和多组学整合分析，擅长通过多维数据揭示疾病机制及临床分型特征。",
      clinicalValue: "可支持肿瘤标志物筛选、患者分层、精准治疗靶点发现。",
      image: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20researcher%20in%20his%2030s%20wearing%20lab%20coat%2C%20single-cell%20genomics%20and%20cancer%20research%20expert%2C%20oncology%20data%20analysis%20specialist%2C%20clean%20white%20background%2C%20professional%20headshot%20portrait%20style&width=300&height=300&seq=expert-he-male&orientation=squarish",
      journals: ["Nature", "Cell", "Nature Communications"]
    },
    {
      name: "贾博士",
      title: "副高",
      specialty: "实验平台与转化研究体系",
      description: "具备丰富的分子、细胞与动物模型经验，擅长搭建与优化复杂体内外实验体系，包括小鼠疾病模型、细胞系构建、病毒包装、流式细胞术、免疫染色、蛋白质组/转录组实验等。",
      clinicalValue: "可实现机制验证、标志物验证与实验转化落地。",
      image: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20scientist%20in%20her%2040s%20wearing%20lab%20coat%20and%20safety%20glasses%2C%20experimental%20platform%20and%20translational%20research%20expert%2C%20laboratory%20research%20specialist%2C%20clean%20white%20background%2C%20professional%20headshot%20portrait%20style&width=300&height=300&seq=expert-jia-female&orientation=squarish",
      journals: ["Neuron", "Cell Research"]
    },
    {
      name: "王博士",
      title: "首席运营专家",
      specialty: "多组学分析统筹与科研转化支持",
      description: "擅长构建多组学分析流程、统筹临床问题解析，并成功协助多篇影响因子 10+ 的研究论文发表。",
      clinicalValue: "可协助医生从数据到论文、从临床问题到科研成果的全链条推进。",
      image: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20operations%20expert%20in%20his%2040s%20wearing%20business%20suit%2C%20multi-omics%20analysis%20and%20research%20translation%20specialist%2C%20scientific%20project%20management%20expert%2C%20clean%20white%20background%2C%20professional%20headshot%20portrait%20style&width=300&height=300&seq=expert-wang-male&orientation=squarish",
      journals: ["Nature Communications", "Advanced Science", "Research"]
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-6">
        {/* 专家团队 */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">专家团队</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {experts.map((expert, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="flex items-start space-x-6">
                {/* 专家照片 */}
                <div className="w-24 h-24 flex-shrink-0 rounded-full overflow-hidden border-4 border-blue-100">
                  <img 
                    src={expert.image} 
                    alt={expert.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                
                {/* 专家信息 */}
                <div className="flex-1">
                  <div className="mb-4">
                    <h3 className="text-xl font-bold text-gray-900 mb-1">{expert.name}</h3>
                    <p className="text-blue-600 font-medium text-sm mb-1">({expert.title})</p>
                    <p className="text-gray-700 font-semibold text-sm">{expert.specialty}</p>
                  </div>

                  {/* 专业描述 */}
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {expert.description}
                  </p>

                  {/* 临床价值 */}
                  <div className="mb-4 p-3 bg-green-50 rounded-lg border-l-4 border-green-400">
                    <p className="text-green-800 text-sm">
                      <span className="font-semibold">👉 临床价值突出点：</span>
                      {expert.clinicalValue}
                    </p>
                  </div>

                  
                  {/* 期刊 */}
                  <div>
                    <h4 className="text-sm font-semibold text-gray-700 mb-2">
                      {expert.name === "王博士" ? "协助发表期刊" : "主要发表期刊"}
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {expert.journals.map((journal, journalIndex) => (
                        <span
                          key={journalIndex}
                          className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs font-medium"
                        >
                          {journal}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
